import fetch from '@/utils/fetch';
import { message } from 'antd';
const model = {
  state: {
    enterpriseSearchParams: {},
    enterpriseTotal: 0,
    enterpriseDataSource: [],
    baseAccountInfo: {},
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { merchantEnterprise }, getState }: any) => ({
    resetSearchParams() {
      merchantEnterprise.setState({ enterpriseSearchParams: {} });
    },
    async getEnterpriseList(params: any) {
      const searchParams = { ...params };
      const res = await fetch('/saasmerchant/web/fscompany/getCompanyList', {
        params: searchParams,
        useJson: true,
        type: 'POST',
      });
      merchantEnterprise.setState({
        enterpriseSearchParams: searchParams,
        enterpriseData: res || {},
        enterpriseTotal: (res && res.total) || 0,
        enterpriseDataSource: (res && res.companyVos) || [],
      });
    },
    async createEnterpriseContract(params: any) {
      return fetch('/saasmerchant/web/fscompany/createCompanyWithContract', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async auditEnterpriseContract(params: any) {
      return fetch('/saasmerchant/web/fscompany/examineCompanyAndContractInfo', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    // 财务审核企业和合同信息
    async financeCompanyAndContractAudit(params) {
      return fetch('/saasmerchant/web/fscompany/examineCompanyAndContractInfoStep2', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    // 新增合同后的初始审核 - 财务审核
    async financeFirstAudit(params) {
      return fetch('/saasmerchant/web/fscompany/contract/examineInitialContractInfoStep2', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    // 财务审核合同信息  通过和驳回
    async financeContractAudit(params) {
      return fetch('/saasmerchant/web/fscompany/contract/auditStep2', {
        params,
        type: 'POST',
        useJson: true,
      });
    },

    async getCompanyBasicInfo(companyId: number) {
      return fetch('/saasmerchant/web/fscompany/getCompanyInfo', {
        params: { companyId },
      });
    },
    async getCompanyContractInfo(params: any) {
      return fetch('/saasmerchant/web/fscompany/getCompanyWithContract', {
        params,
      });
    },
    async getContractInfoByContractId(contractId: string) {
      return fetch('/saasmerchant/web/fscompany/contract/getCompanyContractInfo', {
        params: { contractId },
      });
    },
    async changeSaleMan(params: any) {
      return fetch('/saasmerchant/web/fscompany/updatecompanysell', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async updateCompanyBasicInfo(params: any) {
      return fetch('/saasmerchant/web/fscompany/updateCompanyInfo', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },

    // 创建员工认证信息
    async createCompanyEmployee(params: any) {
      return fetch('/saasmerchant/web/fscompany/createCompanyAuthChannel', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },

    // 编辑员工认证信息
    async updateCompanyEmployee(params: any) {
      return fetch('/saasmerchant/web/fscompany/updateCompanyAuthChannel', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },

    // 获取员工认证信息
    async getCompanyEmployee(params: any) {
      return fetch('/saasmerchant/web/fscompany/getCompanyAuthChannel', { params });
    },

    async getCompanyContractList(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/getContractPage', { params });
    },
    async createContract(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/createContractInfo', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async updateContract(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/updateContractInfo', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async getContractDiffInfo(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/getContractCompareInfo', {
        params,
        useJson: true,
      });
    },
    async firstAudit(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/examineInitialContractInfo', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async auditReject(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/rejectAuditStatus', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async auditPass(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/approveAuditStatus', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async stopContract(params: any) {
      return fetch('/saasmerchant/web/fscompany/contract/terminateContract', { params });
    },
    async getAuditLogList(params: any) {
      return fetch('saasmerchant/web/fscompany/contract/log/getContractLogList', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    async submitAudit(params: any) {
      return fetch('/saasmerchant/web/fscompany/submitForReviewCompanyAndContract', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async getSettleInfo(companyId: string) {
      return fetch('/saasmerchant/fsarea/invoice/settlement/get', {
        params: { companyId },
      });
    },
    async setSettleInfo(params: any) {
      return fetch('/saasmerchant/fsarea/invoice/settlement/set', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async getSubShopData(company_id: string) {
      return fetch('/company/subcompany/subcompanygetlist', {
        params: { company_id },
        type: 'POST',
      });
    },
    async updateInitPassword(id: string) {
      const res = await fetch('/company/account/restpassword', {
        params: { passport_id: id },
        type: 'POST',
      });
      return res;
    },
    async getBaseAccountInfo() {
      const res = await fetch('/saasmerchant/web/bms/getAccountInfo');
      merchantEnterprise.setState({
        baseAccountInfo: res || {},
      });
      return res;
    },
    // 请求员工认证的二维码
    async handleDownloadQrCode(params) {
      const dataUrl = await fetch('/saasmerchant/web/fscompany/getCompanyQrCode', {
        type: 'POST',
        useJson: true,
        params,
      });
      return dataUrl;
    },
    // 员工扫码认证
    async updateCompanyQrStatus(companyId, status) {
      const data = await fetch('/saasmerchant/web/fscompany/updateCompanyQrCodeStatus', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          qrCodeStatus: Number(status),
        },
      });
      if (data) {
        status ? message.success('开启员工扫码认证成功') : message.success('关闭员工扫码认证成功');
      } else {
        message.error('设置失败');
      }
      return data;
    },

    // 查询其他配置中的各种状态
    async getCompanyStatus(params: any) {
      return fetch('/saasmerchant/web/fscompany/getFlagsById', { params });
    },
  }),
};

export default model;
